import './Footer.css';

export default function Footer() {
  return (
    <footer className='footer'>
      <h1 className='heading-footer'>
        Copyright © Prachurya Dash 2021
        <div className='marker'>|</div>
        <br className='break' />
        All Rights Reserved
      </h1>
      <div className='container-terms-and-conditions'>
        <a
          href='https://www.privacypolicies.com/live/737ab509-f1b7-4aac-94b9-591b2a68d939'
          target='_blank'
          className='terms-and-conditions'
          rel='noreferrer'
        >
          Terms & Conditions
        </a>
        <a
          href='https://www.privacypolicies.com/live/a3a40460-25f7-4039-a0f8-3a469db655a4'
          target='_blank'
          className='terms-and-conditions'
          rel='noreferrer'
        >
          Privacy Policy
        </a>
      </div>
      <h2 className='credits'>
        Designed &amp; Developed by{' '}
        <a
          className='glarizon-link'
          target='_blank'
          href='https://glarizon.com/'
          rel='noreferrer'
        >
          Glarizon
        </a>
      </h2>
    </footer>
  );
}
